import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var NativeSelect = React.forwardRef(
  function NativeSelect2({ className, density = "default", ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "select",
      {
        ref,
        className: cn(
          "flex w-full rounded-md border border-input bg-background px-2 py-1 ring-offset-background",
          "focus-ring",
          "disabled:cursor-not-allowed disabled:opacity-50",
          density === "sm" ? "h-8 text-xs" : "h-9 text-sm",
          className
        ),
        ...props
      }
    );
  }
);

export { NativeSelect };
//# sourceMappingURL=chunk-GSFYO3YU.js.map
//# sourceMappingURL=chunk-GSFYO3YU.js.map